import React from "react";
import "./Footer.css";
export default function Footer() {
    return (
        <p> <a href="https://github.com/tania-garcia-gallego">
            Open source code
        </a>  by Tania Garcia Gallego 👩‍💻</p>
    )
}